
<div class="modal active">
  <div class="modal__container" style="max-width:1000px;">
    <div class="fields">
      <h2>Map Preview</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <img src={{imageData}} id="previewMap" crossorigin="anonymous" width="100%">
        <div class="fields__btn">
          <button class="blue" (click)="copyToClipBoard()">Copy to Clipboard</button>
        </div>
      </div>
    </div>
  </div>
</div>
